module.exports = __webpack_public_path__ + "static/img/1000000491_blue.7a3691a1.jpg";